<template>
<v-row justify="center">
<v-dialog v-model="dialog_local" max-width="450">
    <v-form ref="ct" action="#" @submit.prevent="beforeCreateForm('edit')" lazy-validation>
        <v-card class="mx-auto" tile>
        <v-card-title class="justify-space-between" style="background-color: #3D348B; color: white; padding-top: 5px; padding-bottom: 5px">
            {{readonly ? 'View' : 'Update'}} Postcode {{`ID ${modalInfo.Postcode}`}}
            <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
            </v-card-title>
        <v-card-text>
        <v-container class="fill-height"
        fluid >
            <v-row>
                <v-col cols="12" md="12">
                    <v-overlay
                        :absolute="true"
                        :opacity="1"
                        :z-index="999"
                        :value="modal_loader"
                        color="#D2D7DF"
                        >
                        <v-progress-circular indeterminate size="100"></v-progress-circular>
                        </v-overlay>
                    <v-autocomplete
                        dense
                        v-model="form[0].selected"
                        :items="form[0].country"
                        :rules="form[0].rule"
                        item-text="name"
                        item-value="CountryCode"
                        @change="execFilter('country')"
                        label="Select Country"
                        outlined
                        disabled
                        autocomplete="off"
                    ></v-autocomplete>
                    <v-autocomplete
                        dense
                        v-model="form[1].selected"
                        :items="form[1].state"
                        :rules="form[1].rule"
                        item-text="name"
                        item-value="StateCode"
                        @change="execFilter('state')"
                        label="Select State"
                        outlined
                        disabled
                        autocomplete="off"
                    ></v-autocomplete>
                    <v-autocomplete
                        dense
                        v-model="form[2].selected"
                        :items="form[2].city"
                        :rules="form[2].rule"
                        item-text="name"
                        item-value="CityCode"
                        label="Select City"
                        outlined
                        disabled
                        autocomplete="off"
                    ></v-autocomplete>
                     <v-text-field
                        dense
                        outlined
                        v-model="form[3].postcode"
                        :rules="form[3].rule"
                        label="Postcode"
                        required
                        :disabled="readonly"
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[4].createddatetime"
                        label="Created Date"
                        required
                        disabled
                    ></v-text-field>
                    <v-text-field
                        dense
                        outlined
                        v-model="form[5].updateddatetime"
                        label="Updated Date"
                        required
                        disabled
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn v-if="!readonly" tile type="submit" small color="primary"><v-icon left x-small dark>fa fa-save</v-icon>Save</v-btn>
            <v-btn tile color="blue darken-1" text @click="$emit('closed', false)">Close</v-btn>
        </v-card-actions>
        </v-card>
    </v-form>
    <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
    <v-snackbar
        v-model="swal.notification"
        top
        :color="swal.scolor"
        >
            {{ swal.message }}
    </v-snackbar>
</v-dialog>
</v-row>
</template>
<script>
import alertbox from './Alert';
import {ERR} from '../../assets/js/errhandle.js';

export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master', 'allInfo', 'readonly'],
    
    data()  {
        return {
            dialog_local: false,
            innerModal: false,
            form: [ 
                {country: [], itemsFull: [], rule: [], selected: '' },
                {state: [], itemsFull: [], rule: [], selected: '' },
                {city: [], itemsFull: [], rule: [], selected: '' },
                {postcode: '', rule: [] },
                {createddatetime: '', rule: [] },
                {updateddatetime: '', rule: [] },
            ],

            btn_loading: false,

            roles: [],
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                edit_modal: false,
                view_modal: false,
                confirmEdit: false,
                confirmCreate: false,
            },
            swal: {
                notification: false,
                message: '',
                scolor: '',
            },
            modal_loader: false
        }
    },

    components: {alertbox},

    watch: {
        dialog: {
        handler: async function(value) {
            await this.modalHandler();
            if(value == true){
                this.modal_loader = true;
                await this.handleValue();
                this.modal_loader = false;
                this.btn_loading = false;
            }
        },
        },

        dialog_local: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    created(){
        this.$watch(() => this.form[0].country, this.onRuleChange);
        this.$watch(() => this.form[1].state, this.onRuleChange);
        this.$watch(() => this.form[2].city, this.onRuleChange);
        this.$watch(() => this.form[3].postcode, this.onRuleChange);
    },

    methods: {
        async onRuleChange(after, before) {
            this.form[0].rule = [];
            this.form[1].rule = [];
            this.form[2].rule = [];
            this.form[3].rule = [];
        },

        async getAllCountry(){
            let list = [];
            try{
                let response = await this.$store.dispatch("listCountry", {search: ''});
                let dt = response.data.record;
                this.form[0].country.push({name: "Select Country", CountryCode: ""});
                this.form[0].itemsFull.push({name: "Select Country", CountryCode: ""});
                if (response.data.code == "AP000"){
                    for(var i=0; i<dt.length; i++){
                        dt[i].name = `${dt[i].CountryCode} - ${dt[i].CountryName}`;

                        this.form[0].country.push(dt[i]);
                        this.form[0].itemsFull.push(dt[i]);
                    }
                }

                list = dt;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async getAllState(){
            let list = [];
            try{
                let response = await this.$store.dispatch("listState", {search: ''});
                let dt = response.data.record;
                this.form[1].state.push({name: "Select State", StateCode: ""});
                this.form[1].itemsFull.push({name: "Select State", StateCode: ""});
                if (response.data.code == "AP000"){
                    for(var i=0; i<dt.length; i++){
                        dt[i].name = `${dt[i].StateCode} - ${dt[i].StateName}`;

                        this.form[1].state.push(dt[i]);
                        this.form[1].itemsFull.push(dt[i]);
                    }
                }

                list = dt;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async getAllCity(){
            let list = [];
            try{
                let response = await this.$store.dispatch("listCity", {search: ''});
                let dt = response.data.record;
                this.form[2].city.push({name: "Select City", CityCode: ""});
                this.form[2].itemsFull.push({name: "Select City", CityCode: ""});
                if (response.data.code == "AP000"){
                    for(var i=0; i<dt.length; i++){
                        dt[i].name = `${dt[i].CityCode} - ${dt[i].CityName}`;

                        this.form[2].city.push(dt[i]);
                        this.form[2].itemsFull.push(dt[i]);
                    }
                }

                list = dt;
            }

            catch(err){
                console.log(err);
            }

            return list;
        },

        async checkRef(val){
            if (val != undefined){
                if (val.toLowerCase() !== this.modalInfo.CountryCode.toLowerCase()){
                    let system = await this.allInfo;
                    let check = system.some((item) => {
                        return item.CountryCode.toLowerCase() == val.toLowerCase();
                    });

                    return check;
                }

                else{
                    return '';
                }
            }

            else{
                return '';
            }
        },

        async beforeCreateForm(flag){
            this.form[0].rule = [
                v => !!v || 'Country is required',
            ];

            this.form[1].rule = [
                v => !!v || 'State is required',
            ];

            this.form[2].rule = [
                v => !!v || 'City is required',
            ];

            this.form[3].rule = [
                v => !!v || 'Postcode is required',
                v => !v || /^[0-9]*$/.test(v) || 'Only numbers allowed'
            ];

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
                //self.$refs.image.resetValidation();
                //self.$refs.image.reset();

             if (self.$refs.ct.validate()) {
                    self.innerModal = true;
                    self.ma.modalInfo = {id: 1, name: 2};
                    self.ma.modal_action_type = flag;
                }
            });
        },

        modalHandler(){
            this.dialog_local = !this.dialog_local;
        },

        modalCloseHandler(){
            if (this.dialog_local == false){
                this.$emit('closed', false);
            }
        },

        async handleValue(){
            await this.getAllCountry();
            await this.getAllState();
            await this.getAllCity();
            
            this.form[0].selected = this.modalInfo.CountryCode;
            this.execFilter('country');
            this.form[1].selected = this.modalInfo.StateCode;
            this.execFilter('state');
            this.form[2].selected = this.modalInfo.CityCode;
            this.form[3].postcode = this.modalInfo.Postcode;
            this.form[4].createddatetime = this.modalInfo.CreatedDateTime;
            this.form[5].updateddatetime = this.modalInfo.UpdatedDateTime;

            /*
            await this.$nextTick(async () => {
            if (this.$refs['ct'])
                await this.$refs.ct.reset();
                this.form[0].selected = this.modalInfo.CountryCode;
                this.form[1].selected = this.modalInfo.StateCode;
                this.form[2].cityname = this.modalInfo.CityName;
            });
            */
        },

        async execFilter(type){
            if (type == 'country'){
                if (true){
                    let self = this;
                    if (self.form[0].selected != ''){
                        let itm = this.form[1].itemsFull.filter(item => {
                            return item.CountryCode == self.form[0].selected;
                        });

                        this.form[1].state = [];
                        this.form[1].selected = '';

                        this.form[1].state.push({name: "Select State", StateCode: ""});
                        for(var i=0; i<itm.length; i++){
                            itm[i].name = `${itm[i].StateCode} - ${itm[i].StateName}`;
                            this.form[1].state.push({name: itm[i].name, StateCode: itm[i].StateCode});
                        }
                    }

                    else{
                        this.form[1].state = [];
                        this.form[1].selected = '';
                        this.form[1].state = this.form[1].itemsFull;
                    }
                }

                if (true){
                    let self = this;
                    if (self.form[0].selected != ''){
                        let itm = this.form[2].itemsFull.filter(item => {
                            return item.CountryCode == self.form[0].selected;
                        });

                        this.form[2].city = [];
                        this.form[2].selected = '';

                        this.form[2].city.push({name: "Select City", CityCode: ""});
                        for(var i=0; i<itm.length; i++){
                            itm[i].name = `${itm[i].CityCode} - ${itm[i].CityName}`;
                            this.form[2].city.push({name: itm[i].name, CityCode: itm[i].CityCode});
                        }
                    }

                    else{
                        this.form[2].city = [];
                        this.form[2].selected = '';
                        this.form[2].city = this.form[2].itemsFull;
                    }
                }
            }

            if (type == 'state'){
                let self = this;
                    if (self.form[1].selected != ''){
                        let itm = this.form[2].itemsFull.filter(item => {
                            return item.StateCode == self.form[1].selected;
                        });

                        this.form[2].city = [];
                        this.form[2].selected = '';

                        this.form[2].city.push({name: "Select City", CityCode: ""});
                        for(var i=0; i<itm.length; i++){
                            itm[i].name = `${itm[i].CityCode} - ${itm[i].CityName}`;
                            this.form[2].city.push({name: itm[i].name, CityCode: itm[i].CityCode});
                        }
                    }

                    else{
                        this.form[2].city = [];
                        this.form[2].selected = '';
                        this.form[2].city = this.form[2].itemsFull;
                    }
            }
        },

        //set the action to be sent to watcher to execute the create/edit function
        async onConfirm(value){
                if (this.ma.modal_action_type == 'edit'){
                    this.form.flag = 'update';
                    this.$emit('confirm', this.form);
                }

                this.innerModal = false;
        },

        onClosed(value){
            if (value == false){
                this.innerModal = value;
            }
        },
    }
}
</script>